import React from 'react';

import { Header, Footer, ScrollTop, ScrollToTop } from './components';
import { HomePage, AboutUs, TestimonialsPage, BlogGrid, BlogList, BlogSingle, Login, Register, ForgotPwd, ShopGrid, ShopList, Cart, Checkout, Contact, ProductSingle, Wishlist, ServiceSingle, TeamPage, ServicePage, Gallery, OrderConfirmation, FaqPage, PricingPage, TeamSingle, PartnersPage, DestPage, DestSingle, TourPage, TourSingle, ActivityPage, ActivitySingle, Error404, TermServices, PrivacyPolicy, PortfolioPage, PortfolioSingle, TourBooking, CategoryPage, OfferPage } from './sections';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';



const App = () => {

  return (

    <div className='App'>

      {/* Component to Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* Render the header component */}
      <Header />

      <Routes>

        {/*Home*/}
        <Route path='/' element={<HomePage />} />

        {/*About*/}
        <Route path='/About-us' element={<AboutUs />} />
        <Route path='/Team' element={<TeamPage />} /> 
        <Route path='/Team/:id' element={<TeamSingle />} />
        <Route path='/Team/Team-Single' element={<TeamSingle />} />
        <Route path='/Testimonials' element={<TestimonialsPage />} />
        <Route path='/Faqs' element={<FaqPage />} />

        {/*Pages*/}
        <Route path='/Gallery' element={<Gallery />} />
        <Route path='/Pricing' element={<PricingPage />} />

        <Route path='/Activities' element={<ActivityPage />} />   
        <Route path='/Activities/:id' element={<ActivitySingle />} />   
        <Route path='/Activities/Activity-Single' element={<ActivitySingle />} /> 

        <Route path='/Services' element={<ServicePage />} />   
        <Route path='/Services/:id' element={<ServiceSingle />} />   
        <Route path='/Services/Service-Single' element={<ServiceSingle />} /> 

        <Route path='/Portfolio' element={<PortfolioPage />} />   
        <Route path='/Portfolio/:id' element={<PortfolioSingle />} />   
        <Route path='/Portfolio/Project-Single' element={<PortfolioSingle />} /> 

        <Route path='*' element={<Error404 />} />
        <Route path='/Services-Terms' element={<TermServices />} />
        <Route path='/Privacy-Policy' element={<PrivacyPolicy />} />

        <Route path='/Partners' element={<PartnersPage />} />

        {/*Destinations*/}
        <Route path='/Destinations' element={<DestPage />} />
        <Route path='/Destinations/:id' element={<DestSingle />} />
        <Route path='/Destinations/Destination-Single' element={<DestSingle />} />

        {/*Tours*/}
        <Route path='/Tour-Category' element={<CategoryPage />} />    
        <Route path='/Tour-Offers' element={<OfferPage />} />    
        <Route path='/Tours' element={<TourPage />} />    
        <Route path='/Tours/search/:search' element={<TourPage />} />
        <Route path='/Tours/:id' element={<TourSingle />} />   
        <Route path='/Tours/Tour-Single' element={<TourSingle />} /> 
        <Route path='/Tour-Booking' element={<TourBooking />} /> 

        {/*Blogs*/}
        <Route path='/Blog-grid' element={<BlogGrid />} /> 
        <Route path='/Blogs/category/:category' element={<BlogList />} /> 
        <Route path='/Blogs/tag/:tag' element={<BlogList />} /> 
        <Route path='/Blogs/search/:search' element={<BlogList />} /> 
        <Route path='/Blog-list' element={<BlogList />} /> 
        <Route path='/Blogs/:id' element={<BlogSingle  />} />
        <Route path='/Blogs/Blog-Single' element={<BlogSingle />} />

        {/*Shop*/}
        <Route path='/Shop-grid' element={<ShopGrid />} />  
        <Route path='/Shop/category/:category' element={<ShopList />} /> 
        <Route path='/Shop/tag/:tag' element={<ShopList />} /> 
        <Route path='/Shop/search/:search' element={<ShopList />} /> 
        <Route path='/Shop-list' element={<ShopList />} />
        <Route path='/Shop/:id' element={<ProductSingle />} />
        <Route path='/Shop/Product-Single' element={<ProductSingle />} /> 
        <Route path='/Wishlist' element={<Wishlist />} />
        <Route path='/Cart' element={<Cart />} />
        <Route path='/Checkout' element={<Checkout />} />
        <Route path='/OrderConfirmation' element={<OrderConfirmation />} />
        <Route path='/Login' element={<Login />} />  
        <Route path='/Register' element={<Register />} /> 
        <Route path='/Forgot-pwd' element={<ForgotPwd />} /> 

        {/*Contact*/}
        <Route path='/Contact-us' element={<Contact />} /> 

      </Routes>

      {/* Render the footer component */}
      <Footer />

      {/* Scroll to top button */}
      <ScrollTop />
      <ToastContainer />
      
    </div>

  )
}

export default App;
